import type { Translations } from './en';

export const mr: Translations = {
  'nav.inPlay': 'इन-प्ले',
  'nav.aviator': 'Aviator',

  // Bottom navigation bar
  'bottomNav.home': 'होम',
  'bottomNav.inPlay': 'इन-प्ले',
  'bottomNav.offers': 'ऑफर्स',
  'bottomNav.myMarkets': 'माझे मार्केट',
  'bottomNav.referral': 'रेफरल',
  'bottomNav.passbook': 'पासबुक',
  'bottomNav.profile': 'प्रोफाइल',

  'common.deposit': 'जमा करा',
  'common.withdraw': 'पैसे काढा',
  'common.rules': 'नियम',
  'common.all': 'सर्व',
  'common.viewAll': 'सर्व पहा',
  'common.loading': 'लोड होत आहे...',
  'auth.login': 'लॉगिन',
  'auth.signup': 'साइन अप',

  'language.select': 'भाषा निवडा',

  'search.placeholder': 'सामने / कॅसिनो गेम्स शोधा',

  'search.short': 'शोधा',
  'search.matches': 'सामने',
  'search.casinoGames': 'कॅसिनो गेम्स',
  'search.searching': 'शोधत आहे…',
  'search.noResults': '“{term}” साठी कोणतेही परिणाम नाहीत',
  'search.hint': 'संघ, लीग किंवा गेमचे नाव वापरून पहा.',

  'menu.accountStatement': 'खाते विवरण',
  'menu.betHistory': 'बेट इतिहास',
  'menu.activityLogs': 'क्रियाकलाप नोंदी',
  'menu.casinoBetHistory': 'कॅसिनो बेट इतिहास',
  'menu.bonusStatement': 'बोनस विवरण',
  'menu.referral': 'रेफरल',
  'menu.setButtonValues': 'बटण मूल्ये सेट करा',
  'menu.changePassword': 'पासवर्ड बदला',
  'menu.balance': 'शिल्लक',
  'menu.exposure': 'एक्सपोजर',
  'menu.signOut': 'साइन आउट',

  'sidebar.sports': 'खेळ',
  'sidebar.casino': 'कॅसिनो',
  'sidebar.soon': 'लवकरच',
  'sidebar.noCompetitions': 'कोणत्याही स्पर्धा नाहीत',
  'sidebar.noMatches': 'कोणतेही सामने नाहीत',

  'home.casinoProviders': 'कॅसिनो प्रदाते',
  'home.live': 'लाइव्ह',
  'home.virtual': 'व्हर्च्युअल',
  'home.noLiveMatches': 'सध्या कोणतेही लाइव्ह सामने नाहीत',
  'home.noMatches': 'कोणतेही सामने उपलब्ध नाहीत',

  'sport.Cricket': 'क्रिकेट',
  'sport.Football': 'फुटबॉल',
  'sport.Tennis': 'टेनिस',
  'sport.Kabaddi': 'कबड्डी',
  'sport.Politics': 'राजकारण',
  'sport.Basketball': 'बास्केटबॉल',
  'sport.Baseball': 'बेसबॉल',
  'sport.Table Tennis': 'टेबल टेनिस',
  'sport.Volleyball': 'व्हॉलीबॉल',
  'sport.Ice Hockey': 'आइस हॉकी',
  'sport.Rugby': 'रग्बी',
  'sport.Mixed Martial Arts': 'मिक्स्ड मार्शल आर्ट्स',
  'sport.Darts': 'डार्ट्स',
  'sport.Futsal': 'फुटसल',
  'sport.Horse Racing': 'घोड्यांची शर्यत',
  'sport.Greyhound Racing': 'ग्रेहाउंड शर्यत',

  'market.limits': 'किमान: {min} | कमाल: {max}',
  'market.cashout': 'कॅशआउट',

  'menu.profile': 'प्रोफाइल',
  'menu.transactionReport': 'व्यवहार अहवाल',
  'profile.activeBets': 'सक्रिय बेट्स',
  'profile.joinUs': 'आमच्यात सामील व्हा',
  'profile.logout': 'लॉग आउट',
  'profile.balance': 'शिल्लक',

  'profile.description': 'तुमची शिल्लक, वॉलेट, जतन केलेली खाती आणि अहवाल एकाच ठिकाणी.',
  'profile.exposure': 'एक्सपोजर',
  'profile.bonus': 'बोनस',

  // Deposit popup
  'deposit.availableBalance': 'उपलब्ध शिल्लक',
  'deposit.coins': 'कॉइन्स जमा करा',
  'deposit.enterCoins': 'कॉइन्स टाका',
  'deposit.makePayment': 'पेमेंट करा',
  'deposit.loadingMethods': 'पेमेंट पद्धती लोड होत आहेत...',
  'deposit.methodsError': 'पेमेंट पद्धती लोड होऊ शकल्या नाहीत. कृपया पुन्हा प्रयत्न करा.',
  'deposit.noMethods': 'सध्या कोणत्याही पेमेंट पद्धती उपलब्ध नाहीत.',
  'deposit.uploadScreenshot': 'पेमेंट स्क्रीनशॉट अपलोड करण्यासाठी येथे क्लिक करा',
  'deposit.optional': '(पर्यायी)',
  'deposit.utrLabel': 'युनिक व्यवहार संदर्भ (UTR)',
  'deposit.utrPlaceholder': '6 ते 23 अंकी UTR/RRN क्रमांक',
  'deposit.txHash': 'व्यवहार हॅश',
  'deposit.paste': 'पेस्ट',
  'deposit.copy': 'कॉपी',
  'deposit.submit': 'सबमिट करा',
  'deposit.submitting': 'सबमिट होत आहे...',
  'deposit.scanning': 'स्क्रीनशॉटमधून UTR वाचत आहे...',
  'deposit.scanFound': 'तुमच्या स्क्रीनशॉटमधून UTR भरला आहे, तो जुळतो का ते तपासा.',
  'deposit.scanNotFound': 'स्क्रीनशॉटमधून UTR वाचता आला नाही, कृपया तो टाका.',
  'deposit.upiId': 'UPI आयडी',
  'deposit.name': 'नाव',
  'deposit.walletAddress': 'वॉलेट पत्ता',
  'deposit.send': 'पाठवा',
  'deposit.rateUnavailable': 'रूपांतरण दर उपलब्ध नाही, कृपया नंतर पुन्हा प्रयत्न करा.',
  'deposit.range': '{min} ते {max} कॉइन्स दरम्यान जमा करा',
  'deposit.rangeFrom': 'किमान जमा {min} कॉइन्स',
  'deposit.noMethodForAmount': 'या रकमेसाठी कोणतीही पेमेंट पद्धत उपलब्ध नाही. कृपया रक्कम बदला.',
  'deposit.displayName': 'प्रदर्शित नाव',
  'deposit.upiDetails': 'UPI तपशील',
  'deposit.bankDetails': 'बँक तपशील',
  'deposit.cryptoDetails': 'क्रिप्टो तपशील',
  'deposit.bankName': 'बँकेचे नाव',
  'deposit.accountHolderName': 'खातेधारकाचे नाव',
  'deposit.accountNumber': 'खाते क्रमांक',
  'deposit.ifsc': 'IFSC कोड',
  'deposit.amount': 'रक्कम',
  'deposit.hashCode': 'हॅश कोड',
  'deposit.enterHash': 'हॅश कोड टाका',

  // Withdraw popup
  'withdraw.coins': 'कॉइन्स काढा',
  'withdraw.minimum': 'किमान काढण्याची रक्कम {min} कॉइन्स',
  'withdraw.overBalance': 'रक्कम तुमच्या उपलब्ध शिलकीपेक्षा जास्त आहे',
  'withdraw.continue': 'पुढे चला',
  'withdraw.loadingAccounts': 'तुमची खाती लोड होत आहेत...',
  'withdraw.accountsError': 'तुमची खाती लोड होऊ शकली नाहीत. कृपया पुन्हा प्रयत्न करा.',
  'withdraw.noAccounts':
    'अद्याप कोणतेही जतन केलेले खाते नाही. पैसे काढण्यासाठी बँक, UPI किंवा क्रिप्टो खाते जोडा.',
  'withdraw.addAccount': 'खाते जोडा',
  'withdraw.bankAccount': 'बँक खाते',
  'withdraw.cryptoWallet': 'क्रिप्टो वॉलेट',
  'withdraw.accountHolder': 'खातेधारक',
  'withdraw.accountNumber': 'खाते क्रमांक',
  'withdraw.ifsc': 'IFSC',
  'withdraw.amount': 'रक्कम',
  'withdraw.youReceive': 'तुम्हाला मिळेल',
  'withdraw.submit': 'काढा {amount}',
  'withdraw.processing': 'प्रक्रिया सुरू आहे...',
};
